import { useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';
import { BordaSeletor, ConteinerSeletor, InputField, TextoDeErro } from './styles';

export function Seletor({
  nome,
  placeholder,
  titulo,
  opcoes,
  aoAtribuirValor,
  desabilitado = false,
}) {
  const [select, atribuirSelect] = useState();

  const inputRef = useRef(null);

  const { fieldName, registerField, defaultValue, error } = useField(nome);

  const aoMudar = (event) => {
    if (aoAtribuirValor) aoAtribuirValor(event.target.value);

    atribuirSelect(event.target.value);
  };

  useEffect(() => {
    if (defaultValue) {
      atribuirSelect(defaultValue);
      if (aoAtribuirValor) aoAtribuirValor(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      clearValue: () => {
        if (inputRef.current) {
          atribuirSelect('');
          inputRef.current.value = '';
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      <ConteinerSeletor>
        {titulo ? <label>{titulo}</label> : null}
        {opcoes && (
          <InputField
            ref={inputRef}
            placeholder={placeholder}
            defaultValue={defaultValue}
            disabled={desabilitado}
            value={select}
            onChange={aoMudar}
          >
            {opcoes.map((data, i) => (
              <option key={`${i}-${data.value}`} value={data.value}>
                {data.label}
              </option>
            ))}
          </InputField>
        )}
        <BordaSeletor $erro={error} />
        {error && <TextoDeErro>{error}</TextoDeErro>}
      </ConteinerSeletor>
    </>
  );
}
